<template>
  <section class="evento-lux">

    <!-- ===== TARJETA 1: CELEBRACIÓN ===== -->
    <article ref="card1" class="card" aria-label="Celebración">
      <img class="icono" src="@/assets/9.avif" alt="" />
      <h3 class="titulo-script">Ceremonia</h3>
      <p class="hora">12:00 PM</p>
      <p class="lugar">Parroquia de Corpus Christi

</p>
      <p class="direccion">
    C. Río Tecolutla, Jardines de Tuxpan<br>  Túxpam, Veracruz.
      </p>

      <a
        ref="btn1"
        class="btn-rosa"
        href="https://maps.app.goo.gl/rMyiknnXyuMzG6qU9"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

    <!-- ===== TARJETA 2: RECEPCIÓN ===== -->
    <article ref="card2" class="card" aria-label="Recepción">
      <img class="icono" src="@/assets/10.avif" alt="" />
      <h3 class="titulo-script">Celebración</h3>
      <p class="hora">4:00 PM</p>
      <p class="lugar">Sálon Retoños </p>
      <p class="direccion">
     Cam. a Juana Moza 350, Lomas de Fovissste<br> Túxpam, Veracruz.
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/pDw1T9CEUDxz8m6h6"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>
    </article>

  </section>

  
</template>
<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {

    const card1 = ref(null)
    const card2 = ref(null)
    const btn1 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {

      const $ = gsap.utils.selector(cardEl)
      const icono  = $('.icono')
      const titulo = $('.titulo-script')
      const hora   = $('.hora')
      const lugar  = $('.lugar')
      const dir    = $('.direccion')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl, { opacity: 0, y: 40, duration: 0.6 })
        .from(icono,  { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(titulo, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(hora,   { opacity: 0, x: -20, duration: 0.4 }, '-=0.3')
        .from(lugar,  { opacity: 0, x: 20, duration: 0.4 }, '-=0.4')
        .from(dir,    { opacity: 0, y: 20, duration: 0.4 }, '-=0.3')
        .from(btnEl,  { opacity: 0, scale: 0.95, duration: 0.4 }, '-=0.3')

      // brillo botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.8, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      animCard(card1.value, btn1.value)
      animCard(card2.value, btn2.value)
    })

    return { card1, card2, btn1, btn2 }
  }
}
</script>

<style scoped>
/* ==================== ssssssssBASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  min-height: 100%;
  padding: 28px 18px 4px;
  background: rgb(28, 28, 28);
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 28px;  background: rgb(28, 28, 28);
  margin-bottom: 50px;

  text-align: center;
}

/* Icono discreto */
.icono{
  width: 52px;
  height:auto;

  display:block;

  margin: 0 auto 10px;

  opacity: .92;

  /* ✨ convertir a blanco */
  filter:
    brightness(0)
    invert(1)
    drop-shadow(0 1px 0 rgba(255,255,255,.08));
}

/* ✨ TÍTULO PLATEADO CROMADO */
.titulo-script{

  font-family: 'hombre', cursive;
  font-weight: 400;

  font-size: 36px;

  letter-spacing: .6px;

  margin: 4px 0 8px;

  background:
    linear-gradient(
      135deg,
      #4a4a4a 0%,
      #9f9f9f 15%,
      #ffffff 32%,
      #d7d7d7 45%,
      #ffffff 50%,
      #bdbdbd 62%,
      #5f5f5f 100%
    );

  background-size: 220% auto;

  -webkit-background-clip: text;
  background-clip: text;

  color: transparent;

  filter:
    drop-shadow(0 2px 4px rgba(0,0,0,.28))
    drop-shadow(0 0 10px rgba(255,255,255,.18));

  animation:
    brilloCromado 5s linear infinite;

  position: relative;
}

/* ✨ EFECTO BRILLO */
@keyframes brilloCromado{

  0%{
    background-position: 0% center;
  }

  100%{
    background-position: 220% center;
  }

}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: #ffffff;
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #ffffff;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}
.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: #ffffff;
  font-size: 14px;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}

/* ==================== BOTÓN PLATA CROMADO ==================== */
.btn-rosa{
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 13px 24px;

  border-radius: 16px;

  background:
    linear-gradient(
      135deg,
      #4b4b4b 0%,
      #8e8e8e 18%,
      #ffffff 32%,
      #cfcfcf 45%,
      #ffffff 50%,
      #9f9f9f 60%,
      #555555 100%
    );

  background-size: 250% auto;

  color: #080808;

  text-decoration: none;

  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 19px;
  line-height: 1;

  border: 1px solid rgba(255,255,255,.18);

  box-shadow:
    0 4px 10px rgba(0,0,0,.22),
    0 0 18px rgba(255,255,255,.15),
    inset 0 1px 0 rgba(255,255,255,.55);

  overflow: hidden;

  z-index: 0;

  backdrop-filter: blur(4px);

  transition:
    transform .35s ease,
    box-shadow .35s ease,
    background-position .8s ease;
}

/* ✨ HOVER */
.btn-rosa:hover{

  transform:
    translateY(-2px)
    scale(1.03);

  background-position:
    right center;

  box-shadow:
    0 8px 18px rgba(0,0,0,.28),
    0 0 24px rgba(255,255,255,.28),
    inset 0 1px 0 rgba(255,255,255,.75);
}

/* ✨ BRILLO CROMADO */
.btn-rosa::before{
  content: "";

  position: absolute;

  top: 0;
  left: -120%;

  width: 70%;
  height: 100%;

  background:
    linear-gradient(
      120deg,
      transparent,
      rgba(255,255,255,.8),
      transparent
    );

  transform: skewX(-22deg);

  animation: brilloPlata 3.2s infinite;

  z-index: 1;
}

@keyframes brilloPlata{

  0%{
    left: -120%;
  }

  100%{
    left: 180%;
  }

}

/* ✨ TEXTO ENCIMA */
.btn-rosa span,
.btn-rosa{
  position: relative;
  z-index: 2;
}
/* ✨ TEXTO ENCIMA */
.btn-rosa span,
.btn-rosa{
  position: relative;
  z-index: 2;
}
/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper{ height: 64px; display:flex; justify-content:center; align-items:flex-start; margin-top: 12px; }
.linea{
  width: 1px; height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{ font-size: 32px; }
  .hora{ font-size: 22px; }
  .lugar{ font-size: 16px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{ transition: none !important; animation: none !important; }
}








/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final{
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;  
  margin-bottom: -30px;          /* pequeño respiro respecto a la tarjeta */
  overflow: visible;
}

.lux-degradado{
  width: 100%;
  height: 180px;              /* ajusta la altura del degradado a tu gusto */
  background: linear-gradient(
    to top,
    #f6d5e5 0%,               /* rosa baby base */
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

/* Flores pegadas al borde inferior con ligera sombra */
.lux-flores{
  position: absolute;
  bottom: -2px;               /* -2 para tocar el límite inferior visualmente */
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);    /* ancho generoso estilo portada */
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}

</style>
